import { render, staticRenderFns } from "./OrderPaymentMethod.vue?vue&type=template&id=8c127876&scoped=true&"
import script from "./OrderPaymentMethod.vue?vue&type=script&lang=js&"
export * from "./OrderPaymentMethod.vue?vue&type=script&lang=js&"
import style0 from "./OrderPaymentMethod.vue?vue&type=style&index=0&id=8c127876&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c127876",
  null
  
)

export default component.exports